"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "duino-aurisina": {
    "0bf8a0ce": [{
      "hkey": "f89681e6",
      "slug": "sistiana-visogliano",
      "name": "Sistiana-Visogliano",
      "primary": true,
      "skipSearch": false
    }],
    "sistiana": [{
      "hkey": "f89681e6",
      "slug": "sistiana-visogliano",
      "name": "Sistiana-Visogliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "40ac8ede": [{
      "hkey": "f89681e6",
      "slug": "sistiana-visogliano",
      "name": "Sistiana-Visogliano",
      "primary": true,
      "skipSearch": false
    }],
    "visogliano": [{
      "hkey": "f89681e6",
      "slug": "sistiana-visogliano",
      "name": "Sistiana-Visogliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "duino-aurisina"
    }]
  }
};
exports["default"] = _default;